
const DirectiveEntryDiagnosticEntryAwaitingClientReview = () => {
  return (
    <p className="text-warning text-right">
      Aguardando análise do Diagnóstico e orçamento
    </p>
  );
}

export default DirectiveEntryDiagnosticEntryAwaitingClientReview;
